import { Module } from 'vuex';
import { UserGroupState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;
export const state: UserGroupState = {
    userGroups: undefined,
    userGroupDetails: {
        group: undefined,
        users: undefined,
    },
    userGroupCount: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    create: {
        isProcessing: false,
        isCreated: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    addUsers: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    removeUsers: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

export const userGroup: Module<UserGroupState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
